/**
 * @generated SignedSource<<5f6e07ae7579e4f75086a63dcdbe505a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InternNotificationsCardSendTestMutation$variables = {
  body: string;
  brandId: string;
  deviceToken: string;
  platform: string;
  title: string;
};
export type InternNotificationsCardSendTestMutation$data = {
  readonly sendTestPushNotification: {
    readonly error: string | null;
    readonly success: boolean;
  };
};
export type InternNotificationsCardSendTestMutation = {
  response: InternNotificationsCardSendTestMutation$data;
  variables: InternNotificationsCardSendTestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "body"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "brandId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "deviceToken"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "platform"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "body",
        "variableName": "body"
      },
      {
        "kind": "Variable",
        "name": "brandId",
        "variableName": "brandId"
      },
      {
        "kind": "Variable",
        "name": "deviceToken",
        "variableName": "deviceToken"
      },
      {
        "kind": "Variable",
        "name": "platform",
        "variableName": "platform"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "title"
      }
    ],
    "concreteType": "TestPushNotificationResult",
    "kind": "LinkedField",
    "name": "sendTestPushNotification",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "InternNotificationsCardSendTestMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "InternNotificationsCardSendTestMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "fa09db7e9cabb34c1c5497f59ce64dc7",
    "id": null,
    "metadata": {},
    "name": "InternNotificationsCardSendTestMutation",
    "operationKind": "mutation",
    "text": "mutation InternNotificationsCardSendTestMutation(\n  $brandId: ID!\n  $deviceToken: String!\n  $platform: String!\n  $title: String!\n  $body: String!\n) {\n  sendTestPushNotification(brandId: $brandId, deviceToken: $deviceToken, platform: $platform, title: $title, body: $body) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "d7531b6ab5bdce43d2b47d70defb9b41";

export default node;
